import _ from 'lodash';

import { fractional, unitOfMeasure } from './filters';

const weights = () =>
  _(_.range(1 / 4, 5, 1 / 4)) // 1/4, 1/2, 3/4 ...
    .concat(_.range(1 / 3, 5, 1)) // 1/3, 1 1/3, 2 1/3, ...
    .concat(_.range(2 / 3, 5, 1)) // 2/3, 1 2/3, 2 2/3, ...
    .concat(_.range(5, 10 + 1 / 2, 1 / 2)) // 5, 5 1/2, 6, 6 1/2
    .sort((a, b) => (a <= b ? -1 : 1))
    .uniq()
    .value();

export const quantities = {
  pound: weights().map(amount => ({
    id: amount,
    calorie_modifier: null,
    srp_amount: 0,
    default: amount === 1,
    value: [
      fractional(amount.toFixed(2)),
      unitOfMeasure('pound', amount, true),
    ].join(' '),
  })),
  each: _.range(1, 10 + 1).map(amount => ({
    id: amount,
    calorie_modifier: null,
    srp_amount: 0,
    default: amount === 1,
    value: amount,
  })),
  'dry ounce': _.range(1, 10 + 1).map(amount => ({
    id: amount,
    calorie_modifier: null,
    srp_amount: 0,
    default: amount === 1,
    value: [amount, unitOfMeasure('dry ounce', amount, true)].join(' '),
  })),
};

export const QUANTITY_ID = 'qty';



// WEBPACK FOOTER //
// ./src/stubs.js